export const getActiveCurrency = () => {
	return localStorage.getItem("activeCurrency") || "PLN";
};
